export default () => {
  $(document).on('focus input', '[data-article-num-management-filters]', () => {
    const $ownArtNumExportBtn = $(document).find('[data-art-num-management-export]');
    $ownArtNumExportBtn.removeAttr('disabled');
    const $exportBaseUrl = $ownArtNumExportBtn.data('art-num-management-export');
    $ownArtNumExportBtn.attr('href', `${$exportBaseUrl}${window.location.search}`);
  });
};
